<template>
	<div>
		<div class="md-layout">
			<div class="md-layout-item md-small-size-100 md-size-60">
				<md-field>
					<label>ស្វែងរកតាមរយៈ លេខកូដ លេខទូរស័ព្ទ អ្នកផ្ញើ ឬ អ្នកទទួល</label>
					<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
				</md-field>
			</div>
			<div class="md-layout-item md-small-size-30 md-size-40">
				<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">ស្វែងរក
				</md-button>
			</div>
		</div>
		<md-table v-if="packageList.length > 0">
			<md-table-row>
				<!-- <md-table-head>ល.រ.</md-table-head> -->
				<md-table-head>លេខកូដ</md-table-head>
				<md-table-head>ប្រភេទ និងទីតាំង</md-table-head>
				<md-table-head>អ្នកផ្ញើ</md-table-head>
				<md-table-head>អ្នកទទួល</md-table-head>
				<md-table-head>អ្នកដឹកជញ្ជូន</md-table-head>
				<md-table-head>តម្លៃឥវ៉ាន់</md-table-head>
				<md-table-head>ថ្លៃដឹកជញ្ជូន</md-table-head>
				<md-table-head>ស្ថានភាព</md-table-head>
				<md-table-head>សកម្មភាព</md-table-head>
			</md-table-row>

			<md-table-row v-for="(pkg, index) in packageList">
				<!-- <md-table-cell></md-table-cell> -->
				<md-table-cell>​{{ index + 1 }}, <b>{{ pkg.tracking }}</b><br>{{config.datelify(pkg.created_date)}}
				</md-table-cell>
				<md-table-cell><b>{{ pkg.location }}</b><br>{{ pkg.package_type }}</md-table-cell>
				<md-table-cell>{{pkg.sender_phone}} <br>({{pkg.client_name}})</md-table-cell>
				<md-table-cell>{{ pkg.receiver_phone }}</md-table-cell>
				<md-table-cell>
					<span v-if="pkg.status == 'ndv'">មិនមានអ្នកដឹក</span>
					<span v-else>{{ pkg.driver_phone }}<br>({{ pkg.driver_name }})</span>
				</md-table-cell>
				<md-table-cell><b>{{ config.moneylify(pkg.price, pkg.price_currency) }}</b><br><span
						v-if="pkg.price == 0">(ទូទាត់រួច)</span><span v-else>(មិនទាន់ទូទាត់)</span></md-table-cell>
				<md-table-cell><b>{{ config.moneylify(pkg.fee, pkg.fee_currency) }}</b><br>
					({{config.getStatus(pkg.fee_responsible)}})</md-table-cell>
				<md-table-cell>
					<span class="error" v-if="pkg.status == 'ndv'">{{ config.getStatus(pkg.status) }}</span>
					<span class="late" v-if="pkg.status == 'wdv'">{{ config.getStatus(pkg.status) }}</span>
					<span class="neutral" v-if="pkg.status == 'dvr'">{{ config.getStatus(pkg.status) }}</span>
					<span class="green" v-if="pkg.status == 'dlv'">{{ config.getStatus(pkg.status) }}</span>
					<span class="return" v-if="pkg.status == 'rtn'">{{ config.getStatus(pkg.status) }}</span>
				</md-table-cell>
				<md-table-cell>
					<router-link :to="'/driver_packages/detail/' + pkg.hash_id">
						<md-button class="md-just-icon md-simple md-primary">
							<md-icon>visibility</md-icon>
							<md-tooltip md-direction="top">មើលលម្អិត</md-tooltip>
						</md-button>
					</router-link>
				</md-table-cell>

			</md-table-row>
		</md-table>
		<h3 v-if="loaded && packageList == 0">មិនមានកញ្ចប់ឥវ៉ាន់នេះទេ</h3>
	</div>
</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			// this.searchHandler();
		},

		data() {
			return {
				tabName: "first",
				loaded: false,
				search: {
					text: "",
					status: ""
				},
				packageList: []
			}
		},
		methods: {
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/admin/package/search", {
					text: this.search.text,
					status: this.search.status,
					offset: 0
				}).then(data => {
					this.loaded = true;
					this.packageList = data.body.data;

					if (this.packageList.length === 1) {
						this.$router.push("/driver_packages/detail/" + this.packageList[0].hash_id);
					}
				})

			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/DriverPackages/View.vue